<template>
  <router-view/>
</template>

<script lang="ts" setup>
import {useRouter} from "vue-router";
import {Framework, PBEntity, store} from "@mfksoft/utils";
import {onBeforeMount, provide, ref} from "vue";

const router = useRouter();
const routesList = router.getRoutes();

const CurrentUserInfo = ref(PBEntity.UserLoginInfo);
// const RootModules = ref<any[]>([PBEntity.Tree])
// const SubModules = ref<any[]>([PBEntity.Tree])

const verifyPower = (module: string, action: Framework.Operating) => {
  // const power = module && CurrentUserInfo.value?.ModulePermission && CurrentUserInfo.value?.ModulePermission[module] ? (CurrentUserInfo.value?.ModulePermission[module] & action) === action : false;
  // // console.log(module, action, power)
  // return power
  return true;
}


onBeforeMount(async () => {
  console.log("来了，来了")
  if (store.GetToken()) {
    await LoadPermission();
    // connectWS();
  }
})

const LoadPermission = async () => {
  // TODO:获取当前用户信息 这边先写死
  // const resUser = await api.Sys.GetCurrentUserInfo(store.GetToken());
  const resUser = {
    "Result": true,
    "Data": {
      "User": {
        "ID": "10001",
        "Name": "FireTiger",
        "DisplayName": "FireTiger",
        "Password": "78302615c8b79cac8df6d2607f8a83ee",
        "LinkMail": "firetiger@vip.qq.com",
        "UserLevel": 90,
        "RegTime": "1728762845",
        "LastLoginTime": "1729902753",
        "LastLoginIP": "[::1]:56598",
        "LastLoginSource": 100,
        "LastLoginID": "20241026083233167001260032986793",
        "Estate": 1,
        "LoginCount": 78
      },
      "RoleIDs": [
        "20241011205204606001413059571522"
      ],
      "RoleNames": [
        "系统超级管理员"
      ],
      "ModulePermission": {
        "WorkBenches": 1,
        "Sys": 1,
        "User": 15,
        "Role": 15,
        "MchModule": 15,
        "Area": 15,
        "Module": 15,
        "AgentModule": 15,
        "AuthType": 15
      },
      "CurrentLoginIP": "[::1]:56598",
      "LoginTime": "1729902753",
    }
  }
  if (resUser && resUser.Data) {
    // CurrentUserInfo.value = resUser.Data;
    // console.log(resUser.Data)
  }
  // const res = await api.Module.GetAllModules(PBEntity.Platform.AdminPlatform);
  const res = {
    "Result": true,
    "Data": {
      "Datas": [
        {
          "Module": {
            "ID": "20241015223721678001644079525677",
            "Name": "首页",
            "Code": "WorkBenches",
            "IsMenu": 1,
            "Icon": "workbenches",
            "Oper": 1,
            "Estate": 1,
            "Priority": 1,
            "Desc": "工作台",
            "Platform": 100
          },
          "Name": "首页",
          "ID": "WorkBenches"
        },
        {
          "Module": {
            "ID": "20241009232419683001113063116147",
            "Name": "系统管理",
            "Code": "Sys",
            "IsMenu": 1,
            "Icon": "Sys",
            "Oper": 1,
            "Estate": 1,
            "Priority": 2,
            "Platform": 100
          },
          "Name": "系统管理",
          "ID": "Sys"
        },
        {
          "Module": {
            "ID": "20241010194832149000551057465118",
            "ParentID": "20241009232419683001113063116147",
            "Name": "用户&角色",
            "Code": "User",
            "IsMenu": 1,
            "Icon": "Role",
            "Oper": 15,
            "Estate": 1,
            "Priority": 2,
            "Platform": 100
          },
          "Name": "用户&角色",
          "ID": "User"
        },
      ],
    },
    "DataCount": "10"
  }
  if (res && res.Data && Array.isArray(res.Data.Datas)) {
    // // 获取根节点
    // RootModules.value = res.Data.Datas.filter((moduleTree: PBEntity.Tree) => {
    //   const power = CurrentUserInfo.value.ModulePermission[moduleTree.Module?.Code]
    //   if (moduleTree && moduleTree.Module && !moduleTree.Module.ParentID &&
    //       power && (power & Framework.Operating.View) == Framework.Operating.View //是否有查看权限
    //   ) {
    //     moduleTree.Children = [];
    //     return moduleTree;
    //   }
    // });
    // RootModules.value.sort((a: PBEntity.Tree, b: PBEntity.Tree) => a.Module.Priority - b.Module.Priority)
    // SubModules.value = res.Data.Datas.filter((moduleTree: PBEntity.Tree) => {
    //   if (moduleTree && moduleTree.Module && moduleTree.Module.ParentID) {
    //     return moduleTree;
    //   }
    // });
    //
    // SubModules.value.forEach((moduleTree: PBEntity.Tree) => {
    //   const power = CurrentUserInfo.value.ModulePermission[moduleTree.Module?.Code]
    //   if (power && (power & Framework.Operating.View) == Framework.Operating.View) {//是否有查看权限
    //     const parent = RootModules.value.find((m: PBEntity.Tree) => m.Module.ID == moduleTree.Module.ParentID)
    //     if (parent) {
    //       const findRoute = routesList.find((route: RouteRecord) => route.name == moduleTree.Module.Code)
    //       if (findRoute) { //通过路由绑定模块页面跳转的路径
    //         moduleTree.Path = findRoute.path
    //         findRoute.meta.title = moduleTree.Module.Name
    //         parent.Children.push(moduleTree)
    //       }
    //     }
    //   }
    // })
    //
    // RootModules.value.forEach((moduleTree: PBEntity.Tree) => {
    //   const power = CurrentUserInfo.value.ModulePermission[moduleTree.Module?.Code]
    //   if (power && (power & Framework.Operating.View) == Framework.Operating.View) {//是否有查看权限
    //     const findRoute = routesList.find((route: RouteRecord) => route.name == moduleTree.Module.Code)
    //     if (findRoute) { //通过路由绑定模块页面跳转的路径
    //       moduleTree.Path = findRoute.path
    //       findRoute.meta.title = moduleTree.Module.Name
    //     }
    //     if (moduleTree.Children) {
    //       moduleTree.Children.sort((a: PBEntity.Tree, b: PBEntity.Tree) => a.Module.Priority - b.Module.Priority)
    //     }
    //   }
    // })
  }
  // console.debug(RootModules,SubModules)
}

// 下面这边是定义为全局变量 需要引用的地方 通过inject注入
// provide("CurrentUserInfo", CurrentUserInfo);
// provide("RootModules", RootModules);
// provide("SubModules", SubModules);
provide("verifyPower", verifyPower);
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  padding: auto;
}
</style>
